import React, { Component, ChangeEvent } from "react";
import AvatarEditor from "react-avatar-editor";
import { FormattedMessage } from "react-intl";

import { dataURItoBlob } from "../../../common/helpers/dataURItoBlob";
import Draggable from "../Draggable";

import { rotateBase64Image } from "./utils";

import { StyledCropper, Scaler, ScalerDrag, ModifyProfilePicture, Rotate } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";

class Cropper extends Component<IProps, IState> {
    avatar?: AvatarEditor;
    file?: HTMLInputElement;
    state: IState = { x: 40, imageBlob: undefined };
    getImage = () => {
        if (this.avatar) {
            const canvasScaled = this.avatar.getImageScaledToCanvas();
            return canvasScaled.toDataURL("image/jpeg");
        }
    };
    componentDidMount() {
        this.file!.click();
    }
    componentDidUpdate(oldProps: IProps) {
        if (!oldProps.setImageToggle && this.props.setImageToggle) {
            this.props.setImage(this.getImage()!);
        }
    }

    setEditorRef = (editor: AvatarEditor) => (this.avatar = editor);

    onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const target = e.target as HTMLInputElement;
        if (!target || !target.files?.[0]) return;
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files![0]);
        reader.onload = e => {
            let blob = window.URL.createObjectURL(dataURItoBlob(e.target!.result as string)) as string;
            this.props.imageLoaded();
            this.setState({ imageBlob: blob });
        };
    }
    render() {
        const { imageBlob, x } = this.state;
        let scale = 1 + x / 200;
        return (
            <StyledCropper>
                {imageBlob && (
                    <div>
                        <AvatarEditor
                            image={imageBlob}
                            ref={this.setEditorRef}
                            width={200}
                            height={200}
                            border={0}
                            color={[255, 255, 255, 0.6]} // RGBA
                            scale={scale}
                            rotate={0}
                            borderRadius={100}
                            crossOrigin=""
                        />
                        <Rotate>
                            <div
                                className={"link"}
                                onClick={() => {
                                    rotateBase64Image(imageBlob, result => {
                                        this.setState({ imageBlob: result });
                                    });
                                }}
                            >
                                <FormattedMessage {...messages.rotate} />
                            </div>
                        </Rotate>
                        <Scaler>
                            <Draggable
                                onDrag={(x, y) => {
                                    x = Math.min(x, 200);
                                    this.setState({ x });
                                }}
                                position={{
                                    x,
                                    y: 0,
                                }}
                            >
                                <ScalerDrag />
                            </Draggable>
                        </Scaler>
                    </div>
                )}
                <div>
                    <input
                        type="file"
                        style={{ display: "none" }}
                        ref={file => (this.file = file!)}
                        onChange={this.onFileChange}
                    ></input>
                    <ModifyProfilePicture>
                        <div
                            className="link"
                            onClick={() => {
                                this.file!.click();
                            }}
                        >
                            <FormattedMessage {...messages.modify} />
                        </div>
                    </ModifyProfilePicture>
                </div>
            </StyledCropper>
        );
    }
}

export default Cropper;

